import React from 'react';
import { Mail, Phone, Leaf } from 'lucide-react';

const SpicesContact = ({ company }) => (
  <div className="min-h-screen bg-green-50 text-slate-900">
    <div className="py-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
      <div className="bg-gradient-to-br from-slate-900/95 via-green-950/80 to-emerald-950/90 rounded-2xl overflow-hidden shadow-2xl flex flex-col md:flex-row-reverse border-b-4 border-green-500/60 backdrop-blur-xl">
        {/* Left: Info */}
        <div className="p-6 sm:p-8 md:w-1/2 relative z-10 text-white">
          <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-emerald-500/20 blur-xl"></div>
          <h2 className="text-2xl sm:text-3xl font-black mb-4 relative z-10 bg-gradient-to-r from-white to-slate-100 bg-clip-text text-transparent leading-snug">
            Partner <span className="text-transparent bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text">With Us</span>
          </h2>
          <p className="text-slate-200/90 mb-6 text-sm sm:text-base leading-relaxed relative z-10 bg-white/10 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border border-white/20">
            Looking for premium organic spices? Fill out the form and our trade team will reach out within 24 hours with product samples and pricing.
          </p>

          <div className="space-y-3 sm:space-y-4 relative z-10">
            <div className="flex items-center gap-2 sm:gap-3 p-3 sm:p-4 bg-white/15 hover:bg-white/25 rounded-2xl backdrop-blur-sm border border-white/30 hover:border-green-400/50 transition-all duration-300 group">
              <Mail className="text-green-400 group-hover:text-green-300 flex-shrink-0" size={18} />
              <a href='mailto:spicegrainsagrocmb@gmail.com' className="font-semibold text-xs sm:text-sm">spicegrainsagrocmb@gmail.com</a>
            </div>
            <div className="flex items-center gap-2 sm:gap-3 p-3 sm:p-4 bg-white/15 hover:bg-white/25 rounded-2xl backdrop-blur-sm border border-white/30 hover:border-green-400/50 transition-all duration-300 group">
              <Mail className="text-green-400 group-hover:text-green-300 flex-shrink-0" size={18} />
              <a href='mailto:spicegrainsagro@ddlankagroup.com' className="font-semibold text-xs sm:text-sm">spicegrainsagro@ddlankagroup.com</a>
            </div>
            <div className="flex items-center gap-2 sm:gap-3 p-3 sm:p-4 bg-white/15 hover:bg-white/25 rounded-2xl backdrop-blur-sm border border-white/30 hover:border-green-400/50 transition-all duration-300 group">
              <Phone className="text-green-400 group-hover:text-green-300 flex-shrink-0" size={18} />
              <a href='tel:+94778197763' className="font-semibold text-xs sm:text-sm">+94 77 819 7763</a>
            </div>
            <div className="text-xs sm:text-sm text-slate-300 pt-2 sm:pt-4 border-t border-white/30 flex items-center justify-center gap-1 sm:gap-2 font-medium">
              <Leaf className="text-green-400" size={16} />
              Organic Certified | Export Ready | 24/7 Support
            </div>
          </div>
        </div>

        {/* Right: Form */}
        <div className="p-6 sm:p-8 bg-white/80 backdrop-blur-xl md:w-1/2 shadow-2xl border-t border-green-200/40">
          <form
            className="space-y-3 sm:space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              alert("Thank you! We'll contact you within 24 hours.");
            }}
          >
            <input
              type="text"
              placeholder="Full Name *"
              required
              className="w-full p-3 sm:p-4 rounded-2xl border-2 border-green-200/60 bg-white/70 backdrop-blur-sm text-sm sm:text-base placeholder-slate-500 font-medium focus:outline-none focus:border-green-500 focus:shadow-green-300/40 focus:shadow transition-all duration-400"
            />
            <input
              type="email"
              placeholder="Business Email *"
              required
              className="w-full p-3 sm:p-4 rounded-2xl border-2 border-green-200/60 bg-white/70 backdrop-blur-sm text-sm sm:text-base placeholder-slate-500 font-medium focus:outline-none focus:border-green-500 focus:shadow-green-300/40 focus:shadow transition-all duration-400"
            />
            <input
              type="tel"
              placeholder="Phone (Optional)"
              className="w-full p-3 sm:p-4 rounded-2xl border-2 border-green-200/60 bg-white/70 backdrop-blur-sm text-sm sm:text-base placeholder-slate-500 font-medium focus:outline-none focus:border-green-500 focus:shadow-green-300/40 focus:shadow transition-all duration-400"
            />
            <textarea
              placeholder="Tell us about your spice requirements"
              rows="4"
              required
              className="w-full p-3 sm:p-4 rounded-2xl border-2 border-green-200/60 bg-white/70 backdrop-blur-sm text-sm sm:text-base placeholder-slate-500 font-medium resize-vertical focus:outline-none focus:border-green-500 focus:shadow-green-300/40 focus:shadow transition-all duration-400"
            ></textarea>
            <button
              type="submit"
              className="w-full py-4 sm:py-5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-2xl font-black text-sm sm:text-base hover:from-emerald-600 hover:to-green-700 hover:shadow-xl transition-all duration-500 shadow-md hover:scale-[1.02] backdrop-blur-sm group"
            >
              <span className="group-hover:-translate-x-1 transition-transform">
                Request Spice Catalog & Quote
              </span>
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Info */}
      <div className="mt-12 sm:mt-16 text-center text-slate-700/80 max-w-2xl mx-auto">
        <p className="text-lg sm:text-xl font-semibold mb-4 sm:mb-6 bg-gradient-to-r from-slate-800 via-green-900 to-emerald-800 bg-clip-text text-transparent">
          Ready to source the world's finest spices?
        </p>
        <p className="text-sm sm:text-base mb-6 sm:mb-8 leading-relaxed">
          Our team specializes in custom blends and bulk export orders from Sri Lanka's finest plantations.
        </p>
        <div className="flex flex-wrap gap-3 sm:gap-4 justify-center text-xs sm:text-sm font-semibold bg-white/80 backdrop-blur-sm p-4 sm:p-6 rounded-2xl shadow-md mx-4 sm:mx-8 border border-green-100/50">
          <span className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-green-400/20 to-emerald-400/20 rounded-2xl border border-green-200/60 hover:bg-green-400/30 transition-all duration-300">
            🌱 Sugar • Chilies • Rice
          </span>
          <span className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-emerald-400/20 to-green-500/20 rounded-2xl border border-emerald-200/60 hover:bg-emerald-400/30 transition-all duration-300">
            🌿 Wheat Flour • Chickpeas • Channa Dhal
          </span>
          <span className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-yellow-400/20 to-emerald-400/20 rounded-2xl border border-yellow-200/60 hover:bg-yellow-400/30 transition-all duration-300">
            🍂 Lentils • Maize • Essential Oils
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default SpicesContact;
